import { PATH_NAME } from '../../configs/pathName';

const AcceptTermTextGoogle = () => {
  return (
    <p className="text-xs font-light mb-3 italic">
      Bằng việc nhấn &quot;Tiếp tục với Google&quot;, bạn đã đồng ý với{' '}
      <a
        target="_blank"
        rel="noreferrer"
        href={`${window.location.origin}${PATH_NAME.POLICY}`}
        className="underline text-Primary/Main cursor-pointer"
      >
        Điều khoản sử dụng
      </a>{' '}
      của chúng tôi
    </p>
  );
};

export default AcceptTermTextGoogle;
